import React from 'react';
import logo from "../../../assets/لوگو 4.svg";
import {FaBars} from "react-icons/fa"
import { userContext } from '../../../context/usercontext';
import { useContext } from 'react';
const Header = () => {
    const {toggel,setToggel} = useContext(userContext)

    return (
        <div className='userpanel-header'>
        <img src={logo} alt="logo" width="50" height="50" />
        <button className='btn' onClick={()=> {setToggel(!toggel)}}>
        <FaBars/>
        </button>

        </div>
    );
};

export default Header;